import BaseStore from './BaseStore';
import * as wizardConstant from '../utils/wizardConstant';

const defaultFlow = [wizardConstant.STEP_MAIN_ORGANIZATION, wizardConstant.STEP_TENANT];
const groupFlow = [
  wizardConstant.STEP_MAIN_ORGANIZATION,
  wizardConstant.STEP_TENANT,
  wizardConstant.STEP_ORGANIZATION,
  wizardConstant.STEP_MODULE,
];
const userFlow = [wizardConstant.STEP_MAIN_ORGANIZATION, wizardConstant.STEP_TENANT, wizardConstant.STEP_USER];
const areaFlow = [wizardConstant.STEP_MAIN_ORGANIZATION, wizardConstant.STEP_TENANT, wizardConstant.STEP_AREA];

const bedFlow = [
  wizardConstant.STEP_MAIN_ORGANIZATION,
  wizardConstant.STEP_TENANT,
  wizardConstant.STEP_ORGANIZATION,
  wizardConstant.STEP_MODULE,
  wizardConstant.STEP_BED,
];

const deviceFlow = [
  wizardConstant.STEP_MAIN_ORGANIZATION,
  wizardConstant.STEP_TENANT,
  wizardConstant.STEP_ORGANIZATION,
  wizardConstant.STEP_MODULE,
  wizardConstant.STEP_DEVICE,
];

const mapFlow = [
  wizardConstant.STEP_MAIN_ORGANIZATION,
  wizardConstant.STEP_TENANT,
  wizardConstant.STEP_ORGANIZATION,
  wizardConstant.STEP_MODULE,
  wizardConstant.STEP_MAP,
];

export class WizardStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      isRouterStep: false,
      activeStep: 0, // default 0
      activeFlowSteps: defaultFlow,
      navigations: [],
    });
    this.activeFlow = wizardConstant.FLOW_DEFAULT;
    this.activeModuleFlow = null;
  }

  setNavigation(data) {
    this.navigations = data;
  }

  resetNavigation() {
    this.navigations = [];
  }

  resetFlow() {
    this.activeFlowSteps = defaultFlow;
    this.activeFlow = wizardConstant.FLOW_DEFAULT;
  }

  setActiveFlow(task) {
    if (task === wizardConstant.FLOW_GROUP) {
      this.activeFlowSteps = groupFlow;
      this.activeFlow = wizardConstant.FLOW_GROUP;
      this.activeModuleFlow = null;
    } else if (task === wizardConstant.FLOW_USER) {
      this.activeFlowSteps = userFlow;
      this.activeFlow = wizardConstant.FLOW_USER;
    } else if (task === wizardConstant.FLOW_AREA) {
      this.activeFlowSteps = areaFlow;
      this.activeFlow = wizardConstant.FLOW_AREA;
    } else if (task === wizardConstant.FLOW_BED) {
      this.activeFlowSteps = bedFlow;
      this.activeModuleFlow = wizardConstant.FLOW_BED;
    } else if (task === wizardConstant.FLOW_DEVICE) {
      this.activeFlowSteps = deviceFlow;
      this.activeModuleFlow = wizardConstant.FLOW_DEVICE;
    } else if (task === wizardConstant.FLOW_MAP) {
      this.activeFlowSteps = mapFlow;
      this.activeModuleFlow = wizardConstant.FLOW_MAP;
    } else {
      this.activeFlowSteps = defaultFlow;
      this.activeFlow = wizardConstant.FLOW_DEFAULT;
    }
  }

  resetActiveStep() {
    this.activeStep = 0;
  }

  setActiveStep(step) {
    this.activeStep = step;
  }

  nextStep(step) {
    this.activeStep = step + 1;
  }

  backStep(step) {
    this.activeStep = step - 1;
  }

  setRouterStep(status) {
    this.isRouterStep = status;
  }
}

export default new WizardStore();
